import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import type { TJobBoardChannel, TJobBoardChannelKey } from '@bc-library/recruitment'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'jobBoards'

export type TJobBoardChannelState = TJobBoardChannel & {
  /** Site of the firm's list that stands for the board (null until the board is used) */
  website: null | {
    _id: string
    display: string
    feedEnabled: boolean
    settings: Record<string, unknown> | null
  }
}

/** Public feed of the offers ticked for a board, read by the board itself */
export const getJobBoardFeedUrl = (firmId: string, channel: TJobBoardChannelKey, format: 'json' | 'xml' = 'xml') =>
  `${BASE_URL}/${API_MAIN_VERSION}/${resource}/feed/${firmId}/${channel}${format === 'xml' ? '?format=xml' : ''}`

const listChannels = (axios: IFactoryFunctionRequest<TJobBoardChannelState[], undefined>) => (): IFactoryResponse<TJobBoardChannelState[], undefined> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/channels`,
  })
}

type TUpdateChannelBody = { feedEnabled?: boolean, applyToOpenOffers?: boolean }
type TUpdateChannelResponse = TJobBoardChannelState & { addedOffers: number }

const updateChannel = (axios: IFactoryFunctionRequest<TUpdateChannelResponse, TUpdateChannelBody>) =>
  (channel: TJobBoardChannelKey, data: TUpdateChannelBody): IFactoryResponse<TUpdateChannelResponse, TUpdateChannelBody> => {
    return axios({
      method: EMethod.put,
      url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/channels/${channel}`,
      data,
    })
  }

export default (axios: AxiosInstance) => ({
  listChannels: listChannels(useAxios(axios)),
  updateChannel: updateChannel(useAxios(axios)),
})
